// import api from "api/api";
// import serverCall from "api/serverCall";
import {
  createContext,
  useReducer,
  ReactElement,
  useContext,
  useEffect,
} from "react";
// import { SET_NOTIFICATIONS } from "store/reducers/actions";
import dataReducer, { initialState } from "store/reducers/data";
import { useFirebaseContext } from "./FirebaseContext";
// import { INotification } from "types/user";
import { DataContextType } from "types/data";

const DataContext = createContext<DataContextType | null>(null);

export const DataContextProvider = ({
  children,
}: {
  children: ReactElement;
}) => {
  const { isLoggedIn } = useFirebaseContext();
  const [
    state,
    // dispatch
  ] = useReducer(dataReducer, initialState);

  const fetchData = async () => {
    // const promiseArray = [fetchNotifications()];
    // const [notificationResult] = await Promise.allSettled(promiseArray);
    // if (notificationResult?.status === "fulfilled") {
    //   dispatch({
    //     type: SET_NOTIFICATIONS,
    //     payload: {
    //       notifications: notificationResult?.value as INotification[],
    //     },
    //   });
    // }
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchData();
    }
  }, [isLoggedIn]);

  return (
    <DataContext.Provider
      value={{
        ...state,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useDataContext = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error(
      "useDataContext must be used within a OrderContextProvider"
    );
  }
  return context;
};
export default DataContext;
